import React, {useEffect, useState} from 'react';
import {useRouter} from 'next/router';

import AuthTemplate from '@src/templates/Auth';
import ForgotPasswordForm from '@src/components/forms/ForgotPasswordForm';
import PasswordPageIllustrationSrc from '@public/img/illustrations/password.svg';

const errorMessages: {[errorType: string]: string} = {
  invalid_token: 'Your reset link was invalid - please request a new link.',
};

const ForgotPasswordTemplate = () => {
  const router = useRouter();
  const [errorMessage, setErrorMessage] = useState<string | undefined>();

  const {errorType = ''} = router.query;

  useEffect(() => {
    setErrorMessage(errorMessages[errorType as string] ?? '');
  }, [errorType]);

  return (
    <AuthTemplate
      illustrationSrc={PasswordPageIllustrationSrc}
      illustrationAlt="A girl walking to a door with a padlock icon on it.">
      {errorMessage !== undefined && <ForgotPasswordForm initialError={errorMessage} />}
    </AuthTemplate>
  );
};

export default ForgotPasswordTemplate;
